import { View, ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import { LinkButton } from "../../components";
import Feather from "@expo/vector-icons/Feather";
import { colors } from "../../../theme";
import { DocumentPickerAsset } from "expo-document-picker";
import { FieldError } from "react-hook-form";

const formatFilename = (filename: string) => (filename.length > 28 ? `${filename.slice(0, 28).trim()}...` : filename);

interface DocumentSelectedProps {
  label: string;
  value: DocumentPickerAsset;
  handleSelectFile: (onChange: (value: DocumentPickerAsset) => void) => () => void;
  onChange: (value: DocumentPickerAsset) => void;
  error?: FieldError;
  style?: ViewStyle; // required for dividers
}

const DocumentSelected = ({ label, value, error, handleSelectFile, onChange, style }: DocumentSelectedProps) => {
  return (
    <View className="flex-row items-center w-full py-4 px-6" {...{ style }}>
      <View className="mr-6">
        <Feather name="check" size={24} color={colors.green.dark} />
      </View>
      <View className="flex-row justify-between flex-grow">
        <View>
          <Text className="text-regular-tight font-500 text-ink-darkest">{label}</Text>
          <Text className="text-small-right font-400 text-ink-lighter">{!!value && formatFilename(value.name)}</Text>
          {error && <Text className="text-small-tight font-400 text-red-darkest">{error.message}</Text>}
        </View>
        <View className="pr-4 justify-center">
          <LinkButton className="text-regular-normal font-500 text-primary" onPress={handleSelectFile(onChange)}>
            Edit
          </LinkButton>
        </View>
      </View>
    </View>
  );
};

export default DocumentSelected;
